import { DeeplinkService } from './services/deeplink.service';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';

export const DEEP_LINK_STATES: Ng2StateDeclaration[] = [
    {
        name: 'deeplink',
        url: '',
        abstract: true,
        data: {},
    },
    {
        name: 'deeplink.domain',
        url: '/:customer_id/:domain_id/:issue_type_id/:issue_id',
        data: {
            anonymousAccess: false,
        },
        resolve: [
            {
                token: 'deeplinkResolveFn',
                deps: [DeeplinkService, Transition],
                resolveFn: (deeplinkService: DeeplinkService, transition: Transition) => {
                    const params = transition.params();
                    deeplinkService.redirect(params.customer_id, params.domain_id, params.issue_type_id, params.issue_id);
                },
            },
        ],
    },
];
